const FIREBASE_AUTH_NETWORK_REQUEST_FAILED = "auth/network-request-failed";

function readErrorCode(error: unknown): string {
    if (!error || typeof error !== "object") {
        return "";
    }
    const code = (error as {code?: unknown}).code;
    return typeof code === "string" ? code.toLowerCase() : "";
}

/**
 * Translation key for Firebase auth failures thrown before ensure wraps them
 * (password sign-in and getIdToken). auth/too-many-requests stays with the
 * credential error mapper when that code is already handled there.
 * Returns null when this helper does not own the error.
 */
export function getFirebaseAuthSetupFailureKey(error: unknown): string | null {
    if (readErrorCode(error) === FIREBASE_AUTH_NETWORK_REQUEST_FAILED) {
        return "errors.accountSetupNetwork";
    }
    return null;
}
